/**
 * RFC 5545 VEVENT parser — shared by main thread and ICS web worker.
 */

export function parseIcsDates(icsText: string): Record<string, string> {
  const result: Record<string, string> = {};
  const unfolded = icsText.replace(/\r?\n[ \t]/g, "");
  const eventBlocks = unfolded.split(/BEGIN:VEVENT/i).slice(1);

  for (const block of eventBlocks) {
    const dtMatch = block.match(/^DTSTART(?:;[^:]*)?:(\d{4})(\d{2})(\d{2})/m);
    if (!dtMatch) continue;

    const dateStr = `${dtMatch[1]}-${dtMatch[2]}-${dtMatch[3]}`;
    const summaryMatch = block.match(/^SUMMARY(?:;[^:]*)?:(.+)/m);
    const name = summaryMatch
      ? summaryMatch[1].trim().replace(/\\,/g, ",").replace(/\\n/g, " ")
      : "Public Holiday";

    if (!result[dateStr] || result[dateStr] === "Public Holiday") {
      result[dateStr] = name || "Public Holiday";
    }
  }

  return result;
}
